// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact run-status line (memo dev/80) — left side of the chat status
   strip. Muted .systemLine palette; the category tint colors only the dot. */

.enZVgDoBAevI9_abV6b5 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 11px;
  color: var(--curio-text-secondary, var(--curio-text-meta));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.z9ctth4HPx6lVolJO6EY {
  overflow: hidden;
  text-overflow: ellipsis;
  /* Tabular digits: the per-second elapsed must not make the line jitter. */
  font-variant-numeric: tabular-nums;
}

/* Live dot: tinted via the category class (color) → currentColor fill. */
.NxxmS4dBrGbF8KXIzRIX {
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  animation: n_UoAu4uHLwqbajYNKvb 1.6s ease-in-out infinite;
}

@keyframes n_UoAu4uHLwqbajYNKvb {
  0%,
  100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .NxxmS4dBrGbF8KXIzRIX {
    animation: none;
    opacity: 0.8;
  }
}

.WfSbBDljZ98vhXS67iQN {
  flex: none;
  font-size: 10px;
}

.eTWXoU6dLB0aWeqCq6jZ .WfSbBDljZ98vhXS67iQN {
  color: var(--curio-success-text);
}

.yKmLFLCIz57eaNHiFJQ5 {
  color: var(--curio-danger-strong);
}

/* Follow-up marker: same soft-pill grammar as the session chip. */
.tc5o0UBUSDwy_xUOtH42 {
  flex: none;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid var(--curio-warning-bg);
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
  font-size: 10px;
  font-weight: 600;
}

/* Visually hidden, still announced — the live region's phase text. */
.cb47Tslpz_SEDiQQMqIs {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentRunStatusLine.module.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0EAA0E;EAC1E,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,yDAAmD;AACrD;;AAEA;EACE;;IAEE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kEAAkE;AAClE;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Compact run-status line (memo dev/80) — left side of the chat status\n   strip. Muted .systemLine palette; the category tint colors only the dot. */\n\n.line {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  font-size: 11px;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* Tabular digits: the per-second elapsed must not make the line jitter. */\n  font-variant-numeric: tabular-nums;\n}\n\n/* Live dot: tinted via the category class (color) → currentColor fill. */\n.dot {\n  flex: none;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: runStatusPulse 1.6s ease-in-out infinite;\n}\n\n@keyframes runStatusPulse {\n  0%,\n  100% {\n    opacity: 0.35;\n    transform: scale(0.85);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dot {\n    animation: none;\n    opacity: 0.8;\n  }\n}\n\n.icon {\n  flex: none;\n  font-size: 10px;\n}\n\n.done .icon {\n  color: var(--curio-success-text);\n}\n\n.error {\n  color: var(--curio-danger-strong);\n}\n\n/* Follow-up marker: same soft-pill grammar as the session chip. */\n.reviewChip {\n  flex: none;\n  padding: 1px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--curio-warning-bg);\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* Visually hidden, still announced — the live region's phase text. */\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  clip: rect(0 0 0 0);\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"line": `enZVgDoBAevI9_abV6b5`,
	"text": `z9ctth4HPx6lVolJO6EY`,
	"dot": `NxxmS4dBrGbF8KXIzRIX`,
	"runStatusPulse": `n_UoAu4uHLwqbajYNKvb`,
	"icon": `WfSbBDljZ98vhXS67iQN`,
	"done": `eTWXoU6dLB0aWeqCq6jZ`,
	"error": `yKmLFLCIz57eaNHiFJQ5`,
	"reviewChip": `tc5o0UBUSDwy_xUOtH42`,
	"srOnly": `cb47Tslpz_SEDiQQMqIs`
};
export default ___CSS_LOADER_EXPORT___;
